import { useDebugValue, useState } from 'react';
import { useSubscription } from './use-subscription';
import { useForceUpdate } from './helpers';
/**
 * Consume the Observable resource.
 *
 * Unlike Promise, Observable is a multiple push mechanism.
 * This hook triggers extra re-rendering when Suspense should restart.
 *
 * @param resource Observable resource
 */
export function useObservableSuspense(resource) {
    var resourceValue = resource.read();
    var forceUpdate = useForceUpdate();
    var _a = useState(resourceValue), state = _a[0], setState = _a[1];
    useSubscription(resource.shouldUpdate$$, function (valueRef) {
        // ObservableResource supports Stale-While-Revalidate pattern.
        // Schedule states to prevent tearing.
        if (valueRef) {
            setState(valueRef.current);
        }
        else {
            forceUpdate();
        }
    });
    useDebugValue(state);
    return state;
}
//# sourceMappingURL=use-observable-suspense.js.map